export default __webpack_public_path__ + "static/media/governance-hierarchy.f7d0e04a.png";